import { Roles } from '@/lib/Security';

export function CanIgnoreDepartmentAccess(user: { roles: string[] }) {
    return user.roles.includes(Roles.UserAdministrator) || user.roles.includes(Roles.Administrator);
}

export function CanAccessDepartment(user: {roles: string[], departments: string[]}, departmentId: string) {
    return CanIgnoreDepartmentAccess(user) || user.departments.includes(departmentId);
}